import React from "react";
import "../Styles/Projects.css";
import { projectsList } from "../utils/projectsList";

const Projects = () => {
  return (
    <div className="projects-page">
      <h1 style={{textAlign:"center",fontFamily:"roboto",padding:"20px"}}>Our Client Projects</h1>
      <div className="projects-grid">
        {projectsList.map((project, index) =>(
          <div key={index} className="project-card">
            <img src={project.image} alt={project.title} className="project-image" />
            <div className="project-details">
              <h2>{project.title}</h2>
              <p>{project.description}</p>
                          {/*<a href="/products" target="_blank" rel="noopener noreferrer" className="project-link">
                View Project
              </a>*/}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
